/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/laptop'
export default icon
